export default __webpack_public_path__ + "static/media/Head_6_Ear_2_C2.0168c79d.svg";